import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getCertAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/cert', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getCertById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/cert/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createCert = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/cert`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateCert = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/cert/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteCert = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/cert/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteCert = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/cert/${id}`);
    return handleResponse(response, onSuccess, onError);
};